export class Language {
  constructor(
    public id: string,
    public code: string
  ) {}
}
